module.exports = __webpack_public_path__ + "static/img/index_gx2.0fe7fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_gx2.jpg
// module id = O+K+
// module chunks = 0